import { useReducer } from 'react';
import update from 'immutability-helper';
const SET_COUNTRY = 'SET_COUNTRY';
const SET_LANGUAGE = 'SET_LANGUAGE';
const SET_LANGUAGE_AND_COUNTRY = 'SET_LANGUAGE_AND_COUNTRY';
export const LocaleInitialState = {
    language: '',
    country: '',
};
// eslint-disable-next-line default-param-last
const reduce = (state = LocaleInitialState, action) => {
    const { data, type } = action;
    switch (type) {
        case SET_LANGUAGE: {
            return update(state, {
                language: { $set: data.language },
            });
        }
        case SET_COUNTRY: {
            return update(state, {
                country: { $set: data.country },
            });
        }
        case SET_LANGUAGE_AND_COUNTRY: {
            return update(state, {
                language: { $set: data.language },
                country: { $set: data.country },
            });
        }
        default:
            return state;
    }
};
// On every change, save the new locale state to localStorage
const localeReducer = (state, action) => {
    const newState = reduce(state, action);
    window.localStorage.setItem('locale', JSON.stringify(newState));
    return newState;
};
// Load locale from localStorage
const initializer = () => {
    const savedLocale = window.localStorage.getItem('locale');
    let locale = LocaleInitialState;
    if (savedLocale) {
        const parsedLocale = JSON.parse(savedLocale);
        if (parsedLocale) {
            locale = parsedLocale;
        }
    }
    return locale;
};
// Future versions of React allows a third argument for async initializer: useReducer(reducer, {}, initializer)
export const useLocaleReducer = (initialState) => useReducer(localeReducer, initialState || initializer());
// ACTIONS
export const getActions = (dispatch) => ({
    setCountry: (country) => dispatch({ type: SET_COUNTRY, data: { country } }),
    setLanguage: (language) => dispatch({ type: SET_LANGUAGE, data: { language } }),
    setCountryAndLanguage: ({ country, language }) => dispatch({
        type: SET_LANGUAGE_AND_COUNTRY,
        data: { country, language },
    }),
});
